import { ReactNode } from "react";
import { TableFooterTableConfig } from "types/datalist-types";
import CoreComponent from "utilities/component-utilities/CoreComponent";

type DatalistTableFooterPropsType = {
    config?: TableFooterTableConfig;
    name: string;
}

class DatalistTableFooter extends CoreComponent<DatalistTableFooterPropsType> {
    render(): ReactNode {
        if(this.props.config) {
            var list = Array.isArray(this.props.config) ? this.props.config : this.props.config.columns;
            if(list?.length){
                return (
                    <tfoot>
                        <tr>
                            {list.map(f => {
                                return <td key={`datalist-${this.props.name}-footer-${f.name}`} colSpan={f.colSpan} className={f.className}>
                                    {f.value}
                                </td>
                            })}
                        </tr>
                    </tfoot>
                    );
            }
        }
        return <></>
    }
}

export default DatalistTableFooter;
